/**
 * Idaho Form ID W-4 — Line 2 worksheet (page 2). Persisted snapshot lines 1–9 for PDF.
 * Mirrors logic in StateTaxBoiseView.jsx.
 */

function parseOptionalInt(value) {
  if (value === "" || value == null) return null;
  const n = parseInt(String(value), 10);
  return Number.isFinite(n) ? n : null;
}

function parseOptionalNumber(value) {
  if (value === "" || value == null) return null;
  const n = parseFloat(String(value).replace(/,/g, ""));
  return Number.isFinite(n) ? n : null;
}

function fmtMoney(n) {
  if (n === null || Number.isNaN(n)) return "";
  return n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function strOrEmpty(v) {
  if (v === undefined || v === null) return "";
  return String(v);
}

/**
 * @param {Record<string, unknown>} form
 * @returns {Record<string, string>}
 */
export function computeBoiseWorksheetItemizedLineFields(form) {
  const wsJobs = parseOptionalInt(form.boise_worksheet_other_jobs);
  const wsLine2 = wsJobs !== null ? wsJobs * 15000 : null;
  const wsOtherInc = parseOptionalNumber(form.boise_worksheet_other_income);
  const wsLine4 =
    wsLine2 !== null && wsOtherInc !== null
      ? Math.min(wsLine2, wsOtherInc)
      : null;
  const wsItemized =
    parseOptionalNumber(form.boise_worksheet_itemized_line4) ?? 0;
  const wsLine6 = wsItemized * 3868;
  const wsLine7 = wsLine4 !== null ? wsLine4 - wsLine6 : null;
  const wsLine8 = wsLine7 !== null ? wsLine7 * 0.053 : null;
  const wsPeriods = parseOptionalInt(form.boise_worksheet_pay_periods);
  const wsPerPaycheck =
    wsLine8 !== null && wsPeriods !== null && wsPeriods > 0
      ? wsLine8 / wsPeriods
      : null;

  return {
    boise_worksheet_itemized_line_1: strOrEmpty(form.boise_worksheet_other_jobs),
    boise_worksheet_itemized_line_2: fmtMoney(wsLine2),
    boise_worksheet_itemized_line_3: strOrEmpty(form.boise_worksheet_other_income),
    boise_worksheet_itemized_line_4: fmtMoney(wsLine4),
    boise_worksheet_itemized_line_5: strOrEmpty(form.boise_worksheet_itemized_line4),
    boise_worksheet_itemized_line_6: fmtMoney(wsLine6),
    boise_worksheet_itemized_line_7: fmtMoney(wsLine7),
    boise_worksheet_itemized_line_8: fmtMoney(wsLine8),
    boise_worksheet_itemized_line_9: fmtMoney(wsPerPaycheck),
  };
}
